import moment from "moment";
import numeral from 'numeral';

export const formatDate = (value) => value ? moment(value).format('DD.MM.YYYY') : null;
export const formatDateTime = (value) => value ? moment(value).format('DD.MM.YYYY HH:mm') : null;
export const formatPrice = (value) => value ? numeral(value).format('0,0.00') : "0.00";
